import { useTranslation } from 'next-i18next'
import { z } from 'zod'

export const SignInFormSchema = () => {
  const { t } = useTranslation('errors', { keyPrefix: 'validation' })

  return z.object({
    email: z
      .string()
      .email({ message: t('email') })
      .nonempty({ message: t('required') }),
    password: z
      .string()
      .nonempty({ message: t('required') })
      .min(8, { message: t('min', { number: 8 }) })
      .refine(
        (value) => {
          const hasUpperCase = /[A-Z]/.test(value)
          const hasLowerCase = /[a-z]/.test(value)
          const hasNumber = /[0-9]/.test(value)
          return [hasLowerCase, hasUpperCase, hasNumber].every(Boolean)
        },
        { message: t('validPassword') }
      )
  })
}

export const SignInAPISchema = z.object({
  email: z.string().email().nonempty(),
  password: z
    .string()
    .nonempty()
    .min(8)
    .refine((value) => {
      const hasUpperCase = /[A-Z]/.test(value)
      const hasLowerCase = /[a-z]/.test(value)
      const hasNumber = /[0-9]/.test(value)
      return [hasLowerCase, hasUpperCase, hasNumber].every(Boolean)
    })
})
